import { Flex, getThemeMedia, getThemeShadow, styled } from 'front-commons/ds';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

export const PriceSection = styled(Flex)`
	border-top: 1px solid var(--border-primary);
	padding-top: 8px;
`;

export const Portal = styled(DropdownMenu.Portal)``;

export const Content = styled(DropdownMenu.Content)`
	@keyframes downEntrance {
		0% {
			opacity: 0;
			transform: rotateX(-100deg);
			transform-origin: bottom;
		}

		100% {
			opacity: 1;
			transform: rotateX(0deg);
			transform-origin: bottom;
		}
	}

	@keyframes upExit {
		0% {
			opacity: 1;
			transform: rotateX(0deg);
			transform-origin: bottom;
		}

		100% {
			opacity: 0;
			transform: rotateX(70deg);
			transform-origin: bottom;
		}
	}

	box-shadow: inset 0px 8px 8px -8px var(--greys-1000-10);
	background-color: var(--surface-white);

	width: 100vw;
	max-width: 457px;
	height: auto;
	padding: 16px 20px 0;
	left: 0;

	&[data-state='open'] {
		animation: downEntrance 0.5s ease 0s 1 normal forwards;
	}

	&[data-state='false'] {
		animation: upExit 1s ease 0s 1 normal forwards;
	}

	> span {
		display: none;
	}

	@media screen {
		@media (min-width: ${getThemeMedia('medium')}) {
			width: 454px;
		}
	}
`;

export const WrapperPrice = styled(Flex)`
	span {
		text-align: right;
	}

	p {
		text-align: left;
	}
`;
